// ✂️ Copied from shared-universal/utils/helpers.ts ✂️

import { i18n } from '@watershed/intl';
import { formatList } from '@watershed/intl/formatters';

export function joinQuotedWithAnd(words: Iterable<string>): string {
  return formatList(
    Array.from(words).map((word) => '"' + word + '"'),
    { type: 'conjunction', locale: i18n.locale, style: 'long' }
  );
}
